<template>
<div class="chapter">
<div class="inner_page">
<h3 class="ct">Contents</h3>
<p class="toc-entry1"><a href="#/xhtml/fm01">Preface: The Road to Ballymongan</a></p>
<p class="toc-entry1"><a href="#/xhtml/fm02">Acknowledgments</a></p>
<p class="toc-entry1"> </p>
<p class="toc-entry"><a href="#/xhtml/ch01#ch01">1 Goals and Orientations</a></p>
<p class="toc-entry"><span href="#/xhtml/ch02" title="Link target outside of Sample">2 Aghyaran: A Sense of Place and History</span></p>
<p class="toc-entry"><span href="#/xhtml/ch03" title="Link target outside of Sample">3 Ceilis as Storytelling Contexts</span></p>
<p class="toc-entry"><span href="#/xhtml/ch04" title="Link target outside of Sample">4 Wakes as Storytelling Contexts</span></p>
<p class="toc-entry"><span href="#/xhtml/ch05" title="Link target outside of Sample">5 Local Character Anecdotes</span></p>
<p class="toc-entry"><span href="#/xhtml/ch06" title="Link target outside of Sample">6 The Wider Range of Storytelling Genres</span></p>
<p class="toc-entry"><span href="#/xhtml/ch07" title="Link target outside of Sample">7 Anecdotes and the Literary Character</span></p>
<p class="toc-entry"><span href="#/xhtml/ch08" title="Link target outside of Sample">8 Anecdotes and the Local Character</span></p>
<p class="toc-entry"><span href="#/xhtml/ch09" title="Link target outside of Sample">9 Anecdote Cycles and Personality Traits</span></p>
<p class="toc-entry"><span href="#/xhtml/ch10" title="Link target outside of Sample">10 Patterns and Implications</span></p>
<p class="toc-entry"><span href="#/xhtml/ch11" title="Link target outside of Sample">11 Storytelling, Commemoration, and Identity</span></p>
<p class="toc-entry1"> </p>
<p class="toc-entry1"><span href="#/xhtml/notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc-entry1"><span href="#/xhtml/bm01" title="Link target outside of Sample">Bibliography</span></p>
<p class="toc-entry1"><span href="#/xhtml/index" title="Link target outside of Sample">Index</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4137ab5f